import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from 'services/api';

export default function PlansPage() {
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/audits', { params: { statut: 'termine' } })
      .then(r => setAudits(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="content-card">
        <div className="gss-toolbar">
          <div className="content-card-title">Plans de prevention</div>
        </div>

        {loading ? (
          <p style={{ textAlign: 'center', padding: '2rem', color: 'var(--gss-text-light)' }}>Chargement...</p>
        ) : audits.length === 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '60px 20px' }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#DDD" strokeWidth="1.5" style={{ marginBottom: 16 }}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            <div style={{ fontSize: 16, fontWeight: 600, color: '#666' }}>Aucun plan de prevention</div>
            <div style={{ fontSize: 13, color: '#999', marginTop: 4 }}>Les plans sont generes a partir des audits termines.</div>
          </div>
        ) : (
          <div className="gss-table-wrap">
            <table className="gss-table">
              <thead>
                <tr><th>Numero</th><th>Client</th><th>Score</th><th>Niveau</th><th>Date</th><th>Action</th></tr>
              </thead>
              <tbody>
                {audits.map(a => (
                  <tr key={a.id}>
                    <td><strong>{a.numero}</strong></td>
                    <td>{a.client_nom || '-'}</td>
                    <td>{a.score_total}/100</td>
                    <td>
                      <span className={`gss-badge gss-badge-${a.niveau_risque === 'critique' ? 'danger' : a.niveau_risque === 'eleve' ? 'warning' : a.niveau_risque === 'moyen' ? 'info' : 'success'}`}>
                        {(a.niveau_risque || '').toUpperCase()}
                      </span>
                    </td>
                    <td>{a.date_visite?.split('T')[0] || a.created_at?.split('T')[0] || '-'}</td>
                    <td>
                      <button className="gss-btn-sm" onClick={() => navigate(`/audit/${a.id}/plan`)}>
                        Voir le plan
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
